import { AppContext } from "@edx/frontend-platform/react";
import React, { useContext, useEffect, useState } from "react";

const MainPopup = () => {
  const { config } = useContext(AppContext);
  const [isVisible, setIsVisible] = useState(null);
  const handleClosePopup = () => {
    setIsVisible(false);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 767);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 767);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  const parseStyle = (styleString) => {
    if (!styleString) return {};

    return Object.fromEntries(
      styleString.split(";")
        .filter(Boolean)
        .map(rule => rule.split(":").map(v => v.trim()))
    );
  };

  const desktopMessageStyle = parseStyle(config?.BANNER_MESSAGE_STYLE);
  const mobileMessageStyle  = parseStyle(config?.BANNER_MESSAGE_STYLE_MOBILE);
  const finalMessageStyle = isMobile
    ? { ...desktopMessageStyle, ...mobileMessageStyle }
    : desktopMessageStyle;

  const desktopTitleStyle = parseStyle(config?.BANNER_TITLE_STYLE);
  const mobileTitleStyle  = parseStyle(config?.BANNER_TITLE_STYLE_MOBILE);
  const finalTitleStyle = isMobile
    ? { ...desktopTitleStyle, ...mobileTitleStyle }
    : desktopTitleStyle;

  useEffect(() => {
    if (config.DISPLAY_BANNER) {
      setIsVisible(config?.DISPLAY_BANNER);
    }
  }, [config.DISPLAY_BANNER]);

  return (
    <>
      {isVisible && (
        <div className="main-popup">
          <div className="inner-MainBox">
            <div className="main-box">
              <div className="close-icon">
                <span
                  onClick={handleClosePopup}
                  className="w3-button w3-display-topright"
                >
                  &times;
                </span>
              </div>
              <div className="banner-logo">
                <img src="https://iimbx-hawthorn-storage.s3.ap-south-1.amazonaws.com/banner-logo.png" alt="IIMBx Logo" />
              </div>
              <div className="imported-title" style={finalTitleStyle}>
                {config?.BANNER_TITLE}
              </div>
              <div style={finalMessageStyle} dangerouslySetInnerHTML={{ __html: config?.BANNER_MESSAGE }}>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MainPopup;
